import { INameIDData } from "../common/INameIDData.intf";
import { IPermissionData } from "../permission";
import { createMergeToDefaultData, mergeDataWith } from "../utils/mergeToDefaultData";
import { IActionGroup } from "./IActionGroup.intf";
import { projectEventUtils } from "../events/projectEventUtils";
import { IActionOrTriggerListPageParams } from "@app/static";
// 静态数据放这里
export interface IActionJavaData {
    //com.fanfanlo.droidlib.auto.command.a11y.action.ActionA11yNode2
    // readonly type: string
    // // action数据库中的id，现在用ulid生成
    // id:string
}
// 动态参数放这里
export interface IActionShellData {
}

export interface IActionData<T extends IActionShellData, U extends IActionJavaData> extends INameIDData<T, U>{
    //com.fanfanlo.droidlib.auto.command.a11y.action.ActionA11yNode2
    readonly type: string
    // action数据库中的id，现在用ulid生成
    id:string
    permissions?:IPermissionData[]
    // shellData?:T
    javaData:U
}

export interface IOnChangeActionJavaDataProps{
    query:IActionOrTriggerListPageParams,
    // 采用projectEventUtils.dispatchEditEvent的目的是能够在页面刷新后依然能通过url数据更新javaData，但是如果使用注入函数的方法就做不到这点了，所以这个参数当前分析是不要用，以后如果要启用，需要先考虑一下上面用projectEventUtils.dispatchEditEvent的优点是否能被替代才行。
    // 但是现在也面临修改数据后，其它未被修改的数据会需要重新初始化的问题，而projectEventUtils.dispatchEditEvent里是merge，并没有重新初始化其它数据的功能。
    //再次论证。这个方法现在是刷新页面即丢失的，并不是能够通过url来更新数据的。所以似乎可以启用这个方法
    // onJavaDataChangeDataSelect?:(data:any)=>void
    //尝试考虑用这个方式来替代上面注入函数的修改方式。
    //查找到action后，用action proxy的dispatcher派发事件来更新数据
    onDataSelectedEventType?:string
}
export interface IActionUtils<T extends IActionData<IActionShellData, IActionJavaData>>{
    type:string
    init:()=>void
    mergeDataToDefultData:(data:Partial<T>)=>T
    createDefultData:()=>T
    create:(actionGroup:IActionGroup, data?:Partial<T>)=>void
    update(action:T, data?:Partial<T>):void
    UI:(data:T)=>React.ReactNode
    //点击更改按钮后调用不是page页面的时候需要，例如更改返回首页.
    onClickChange?:(data:IOnChangeActionJavaDataProps, ...rest:any[])=>void
}

export interface IActionUtilsMap{
    [key:string]:IActionUtils<any>
}

export const ActionUtilsMap:IActionUtilsMap = {}

export function registerActionUtils(key:string,utils:IActionUtils<any>){
    if(key in ActionUtilsMap){
        throw new Error(`ActionUtilsMap already has key: ${key}`)
    }
    // console.log('registerActionUtils', key, utils)
    ActionUtilsMap[key] = utils
}

export function getActionUtils<T extends IActionData<IActionShellData, IActionJavaData>>(key:string):IActionUtils<T>{
    return ActionUtilsMap[key]
}

export function createActionUtils<T extends IActionData<IActionShellData, IActionJavaData>>(type:string, init:()=>void, createDefultData:()=>T, UI:(data:T)=>React.ReactNode):IActionUtils<T>{
    const res = {
        type,
        mergeDataToDefultData:createMergeToDefaultData(createDefultData),
        createDefultData,
        create:(actionGroup:IActionGroup, data?:Partial<T>)=>{
            const action = createDefultData()
            actionGroup.list.push(action)
        },
        update:(action:T, data?:Partial<T>)=>{
            mergeDataWith(action, data)
        },
        UI,
        init,
    }
    registerActionUtils(type,res)
    return res
}

 
